import React from 'react';
import "../style/Updown.scss";

const Updown = ({upload,image}) => {
    return (
        <>
            {
                image ? 
                <button className='remove' onClick={
                    () => upload(null)
                }>remove image</button> : 
                <button className='upload'>
                    <label className='user-data' htmlFor='input-file'>upload image</label>
                    <input type="file"
                        id='input-file'
                        onChange={e => upload(e.target.files[0])}
                        style={{display: "none"}}   
                    />
                </button>
            }
        </>
    );
};

export default Updown;